<template>
    <div class="p-1">
        <div class="row">
            <div class="col-lg-6 mb-1">
                <div class="row">
                    <div class="col-12 mb-1">
                        <div class="border rounded p-75">
                            <h4>Fiziksel Ehliyet</h4>
                            <div class="row">
                                <div class="col-lg-6 mb-1">
                                    <label class="form-label">Sürücü Sicil Numarası</label>
                                    <v-validator :errors="errors" parameter="EmployeeDriverLicenseInformation.DriverLicenseNumber" :watch="value.DriverLicenseNumber">
                                        <input class="form-control" v-model="value.DriverLicenseNumber" placeholder="Ehliyet Numarası"/>
                                    </v-validator>
                                </div>
                                <div class="col-lg-6 mb-1">
                                    <label class="form-label">Verildiği İl</label>
                                    <v-validator :errors="errors" parameter="EmployeeDriverLicenseInformation.DriverLicenseIssueProvinceId" :watch="provinces">
                                        <v-select-list v-model="province" placeholder="Verildiği İl" label="Name" :options="provinces"/>
                                    </v-validator>
                                </div>
                                <div class="col-lg-6 mb-1">
                                    <label class="form-label">Belge Seri Numarası</label>
                                    <v-validator :errors="errors" parameter="EmployeeDriverLicenseInformation.DocumentSerialNumber" :watch="value.DocumentSerialNumber">
                                        <input class="form-control" v-model="value.DocumentSerialNumber" placeholder="Belge Seri Numarası"/>  
                                    </v-validator>      
                                </div>
                                <div class="col-lg-6 mb-1">
                                    <label class="form-label">Geçerlilik Başlangıç Tarih</label>
                                    <v-validator :errors="errors" parameter="EmployeeDriverLicenseInformation.ValidityStartDate" :watch="value.ValidityStartDate">
                                        <v-date-picker placeholder="Geçerlilik Başlangıç Tarih" v-model="value.ValidityStartDate"></v-date-picker>
                                    </v-validator>
                                </div>
                                <div class="col-lg-6">
                                    <label class="form-label">Geçerlilik Bitiş Tarih</label>
                                    <v-validator :errors="errors" parameter="EmployeeDriverLicenseInformation.ValidityEndDate" :watch="value.ValidityEndDate">
                                        <v-date-picker placeholder="Geçerlilik Bitiş Tarih" v-model="value.ValidityEndDate"></v-date-picker>
                                    </v-validator>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="border rounded p-75">
                            <h4>Dijital Ehliyet</h4>
                            <div class="row">
                                <div class="col-md-6 mb-1">
                                    <label class="form-label">Geçerlilik Başlangıç Tarihi</label>
                                    <v-validator :errors="errors" parameter="EmployeeDriverLicenseInformation.DigitalLicenseValidityStartDate" :watch="value.DigitalLicenseValidityStartDate">
                                        <v-date-picker placeholder="Geçerlilik Başlangıç Tarih" v-model="value.DigitalLicenseValidityStartDate"></v-date-picker>
                                    </v-validator>
                                </div>
                                <div class="col-md-6 mb-1">
                                    <label class="form-label">Geçerlilik Bitiş Tarihi</label>
                                    <v-validator :errors="errors" parameter="EmployeeDriverLicenseInformation.DigitalLicenseValidityEndDate" :watch="value.DigitalLicenseValidityEndDate">
                                        <v-date-picker placeholder="Geçerlilik Bitiş Tarih" v-model="value.DigitalLicenseValidityEndDate"></v-date-picker>
                                    </v-validator>
                                </div>
                                <div class="col-12">
                                    <div class="alert alert-dark mb-0 px-1 pt-50 py-1">
                                        <label class="form-label">Numara</label>
                                        <div class="row align-items-start">
                                            <div class="col">
                                                <v-validator :errors="errors" parameter="EmployeeDriverLicenseInformation.DigitalLicenseNumber" :watch="value.DigitalLicenseNumber">
                                                    <input class="form-control" v-model="value.DigitalLicenseNumber" placeholder="Dijital Belge Numarası"/>
                                                </v-validator>
                                            </div>
                                            <div class="col-auto">
                                                <button :disabled="!id" v-on:click="getDigitalNumbers" class="btn btn-success btn-icon">
                                                    <b-spinner small v-if="digitalNumbersLoading"></b-spinner>
                                                    <feather-icon v-else icon="SearchIcon"></feather-icon>
                                                </button>
                                            </div>
                                            <div class="col-12">
                                                <div v-if="value.DigitalLicenseNumber && pairedDigitalLicense && digitalLicenseNumbers.length" class="text-success mt-50">Dijital belge numarası kayıtlar ile eşleşmektedir.</div>
                                                <div v-else-if="value.DigitalLicenseNumber && !pairedDigitalLicense  && digitalLicenseNumbers.length" class="text-danger mt-50">Dijital belge numarası kayıtlar ile eşleşmemektedir.</div>
                                                <div v-else-if="value.DigitalLicenseNumber && digitalNumbersRequested && digitalLicenseNumbers.length == 0" class="text-danger mt-50">Dijital belge numarası kaydı bulunmamaktadır.</div>
                                                <template v-for="(license,index) in digitalLicenseNumbers">
                                                    <b-form-radio :key="index" v-model="value.DigitalLicenseNumber" :value="license" class="mt-50">
                                                        <span :class="{'font-weight-bolder':license == value.DigitalLicenseNumber}">{{license}}</span>
                                                    </b-form-radio>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <table class="table table-bordered table-sm ">
                    <thead>
                        <tr>
                            <th class="text-center">Seç</th>
                            <th>Belge Sınıfı</th>
                            <th>Geçerlilik Başlangıç Tarihi</th>
                            <th>Geçerlilik Bitiş Tarihi</th>
                        </tr>
                    </thead>
                    <tr v-for="(lc,index) in value.EmployeeDriverLicenseClassInformations" :key="lc.Id">
                        <td class="text-center">
                            <b-form-checkbox class="pl-2 d-inline-block" :id="'DL'+lc.ClassName" v-model="lc.IsActive"></b-form-checkbox>
                        </td>
                        <td>
                            <div class="d-flex align-items-center" >
                                <feather-icon class="text-muted mr-50" icon="AlertCircleIcon" v-b-tooltip.noninteractive.hover.bottom="getCoverage(lc)"></feather-icon> 
                                <b>{{lc.ClassName}}</b>
                            </div>
                        </td>
                        <td>
                            <v-validator :errors="errors" :parameter="`EmployeeDriverLicenseInformation.EmployeeDriverLicenseClassInformations[${index}].ValidityStartDate`" :watch="lc.ValidityStartDate">
                                <v-date-picker :disabled="!lc.IsActive" v-model="lc.ValidityStartDate" v-on:change="makeGroup(lc)" placeholder="Geçerlilik Başlangıç Tarihi"></v-date-picker>
                            </v-validator>
                        </td>
                        <td>
                            <v-validator :errors="errors" :parameter="`EmployeeDriverLicenseInformation.EmployeeDriverLicenseClassInformations[${index}].ValidityEndDate`" :watch="lc.ValidityEndDate">
                                <v-date-picker :disabled="!lc.IsActive" v-model="lc.ValidityEndDate" v-on:change="makeGroup(lc)" placeholder="Geçerlilik Bitiş Tarihi"></v-date-picker>
                            </v-validator>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="text-right mt-1">
            <v-executer :loading="loading" :action="save" text="Ehliyet Bilgilerini Kaydet"></v-executer>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox,BSpinner,BFormRadio,VBTooltip } from 'bootstrap-vue'
import SystemDataApi from '@/api/system-data'
import EmployeeOperationsApi from '@/api/employee-operations' 
import Additional from '@/utilities/additional'
import { DriverLicenseGroup } from './driver-license-group'
import moment from 'moment'

export default {
    components:{
        BFormCheckbox,
        BSpinner,
        BFormRadio
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    props:{
        value:Object,
        id:[String,Number],
        getPersonal:Function,
        isDriver:Boolean,
        candidate:Boolean
    },
    data(){
        return{
            driverLicenseGroup:DriverLicenseGroup,
            provinces:[],
            loading:false,
            digitalNumbersLoading:false,
            digitalNumbersRequested:false,
            digitalLicenseNumbers:[],
            digitalLicenseNumber:null,
            errors:{}
        }
    },
    mounted(){
        this.getProvinces()
    },
    methods:{
        getProvinces(){
            SystemDataApi.Province().then(response=>{
                this.provinces = response.data.Data
            })
        },
        // Aday personel akışında ehliyet sınıfı satırları (A1, B, C...) backend payload'ında gelmeyebilir;
        // bu durumda tablo boş kalır ve kullanıcı sınıf seçemez. Normal personelde backend tüm sınıfları
        // (seçilmemiş olanlar dahil) gönderir; aynı davranışı burada DriverLicenseClass listesinden kurarız.
        ensureDriverLicenseClasses(){
            if(!this.value) return
            const mevcut = this.value.EmployeeDriverLicenseClassInformations || []
            if(mevcut.length > 0) return
            SystemDataApi.DriverLicenseClass().then(response=>{
                const classes = response.data.Data || []
                this.value.EmployeeDriverLicenseClassInformations = classes.map(c=>({
                    DriverLicenseClassId: c.Id,
                    ClassName: (c.Name || '').toUpperCase(),
                    IsActive: false,
                    ValidityStartDate: null,
                    ValidityEndDate: null,
                    Checked: false
                }))
            }).catch(err=>{
                this.$result(null,err)
            })
        },
        async save(){
            let value = structuredClone(this.value)
            value.EmployeeDriverLicenseClassInformations = value.EmployeeDriverLicenseClassInformations.map(ci=>({
                ...ci,
                Checked:ci.IsActive
            }))
            value.Driver = this.isDriver
            const candidateEmployeeId = this.candidate && ![0, "0"].includes(this.id) ? this.id : null
            let data = {
                Step:3,
                EmployeeId:this.id,
                CandidateEmployeeId:candidateEmployeeId,
                EmployeeDriverLicenseInformation:value,
            }
            let formData = await Additional.ToFormData(data)
            this.loading = true
            const submit = this.candidate ? EmployeeOperationsApi.Employee.Candidate.CreateOrUpdate : EmployeeOperationsApi.Employee.CreateOrUpdate
            submit(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.getPersonal()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        getDigitalNumbers(){
            this.digitalNumbersLoading = true
            EmployeeOperationsApi.Employee.GetDigitalNumbers(this.id).then(res=>{
                this.digitalNumbersLoading = false
                if(res.data.Success){
                    this.digitalLicenseNumbers = []
                    this.digitalLicenseNumbers = res.data.Data
                    this.digitalNumbersRequested = true
                }
            }).catch(err=>{
                this.$result(null,err)
                this.digitalNumbersLoading = false
            })
        },
        getCoverage(current){
            let coverage = this.driverLicenseGroup.find(dlg => dlg.code == current.ClassName)?.coverage || []
            if(coverage.length == 0){
                return "Bu ehliyet sınıfının kapsamı bulunmamaktadır."
            }else {
                return `Bu ehliyet sınıfı ${coverage.join(', ')} sınıflarını kapsar.`
            }

        },
        makeGroup(current){
            let coverage = this.driverLicenseGroup.find(dlg => dlg.code == current.ClassName)?.coverage || []
            if(coverage){
                this.value.EmployeeDriverLicenseClassInformations.forEach(lc=>{
                    if(coverage.includes(lc.ClassName) && current.ValidityEndDate){
                        if(!lc.ValidityStartDate && !lc.ValidityEndDate && !lc.IsActive){
                            lc.IsActive = true
                            lc.ValidityStartDate = current.ValidityStartDate
                            lc.ValidityEndDate = current.ValidityEndDate
                        }
                    }
                })
            }
        }
    },
    watch:{
        // value parent tarafından (aday/personel get) asenkron dolabilir; liste boş kaldıkça sınıfları kur.
        value:{
            immediate:true,
            handler(){
                this.ensureDriverLicenseClasses()
            }
        }
    },
    computed:{
        province:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.DriverLicenseIssueProvinceId)
            },
            set:function(value){
                this.value.DriverLicenseIssueProvinceId = value?.Id || null
                this.value.DriverLicenseIssueProvinceName = value?.Name
            }
        },
        pairedDigitalLicense(){
            return this.digitalLicenseNumbers.includes(this.value.DigitalLicenseNumber)
        }
    }
}
</script>
